import React, { useState, useCallback, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import { SlideUpTransition } from '../../Components/Transitions/Transitions';
import BaseDialog from '../../Components/Dialogs/BaseDialog';

import PinHelp from '../../Assets/images/certificate_pin_help.png';

function CertificatePinHelpDialog(props) {
  const { open = true, onClose, title = 'Título' } = props;
  const classes = useStyles();

  const [loading, setLoading] = useState(true);

  const onImageLoaded = useCallback(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    setLoading(true);
  }, []);

  const renderContent = () => {
    return (
      <>
        <img
          className={classes.image}
          src={PinHelp}
          alt="Pin Help"
          onLoad={onImageLoaded}
        />
      </>
    );
  };

  const isMobileSize = useMediaQuery(theme => theme.breakpoints.down('xs'));

  return (
    <BaseDialog
      open={open}
      loading={loading}
      handleClose={onClose}
      title={title}
      actions={() => null}
      content={renderContent}
      fullScreen={isMobileSize}
      TransitionComponent={isMobileSize ? SlideUpTransition : undefined}
    />
  );
}

const useStyles = makeStyles(theme => ({
  image: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 536,
      height: 236
    }
  }
}));

export default CertificatePinHelpDialog;
